<div
  class="bg-card rounded-2xl shadow-sm cursor-pointer hover:shadow-md transition-shadow border border-card-muted dark:border-foreground"
>
  <div class="p-4">
    <!-- Header -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-1.5">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="#3B82F6"
        >
          <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
        </svg>
        <h3 class="text-foreground text-lg font-semibold">Hydration</h3>
      </div>

      <div class="flex items-center gap-2">
        <p-dropdown
          [options]="intakeOptions"
          [(ngModel)]="selectedIntake"
          optionLabel="label"
          optionValue="value"
          (click)="$event.stopPropagation()"
          styleClass="w-[110px] h-[28px] flex items-center text-[12px] font-bold bg-white dark:bg-gray-800 border border-gray-200 dark:border-foreground shadow-sm rounded-lg"
          panelStyleClass="text-xs font-medium"
        ></p-dropdown>
        <button
          class="flex items-center gap-1 px-3 py-1 bg-gray-50 dark:bg-gray-800/50 rounded-full hover:bg-gray-100 transition dark:border-foreground dark:border"
          (click)="$event.stopPropagation(); navigateToTrends()"
        >
          <span class="text-sm font-medium text-foreground">View Trends</span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="7" y1="17" x2="17" y2="7"></line>
            <polyline points="7 7 17 7 17 17"></polyline>
          </svg>
        </button>
      </div>
    </div>

    <!-- Intake Info -->
    <div class="mb-2">
      <div class="flex items-center justify-between mb-2">
        <p class="text-[11px] text-gray-400 font-medium">Today's Intake</p>
      </div>
      <div class="flex items-center justify-between mt-1">
        <div class="flex items-baseline gap-0.5">
          <span class="text-3xl font-extrabold text-[#101828] dark:text-gray-100 tracking-tight"
            >{{ formatMlToL(intake) }}L</span
          >
          <span class="text-sm font-medium text-gray-400">/ {{ formatMlToL(goal) }}L</span>
        </div>

        <!-- Controls & Glasses -->
        <div class="flex items-center gap-2">
          <!-- Decrement -->
          <button
            (click)="$event.stopPropagation(); decrement()"
            [disabled]="intake <= 0"
            class="w-7 h-7 flex items-center justify-center rounded-full bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 disabled:opacity-30 transition border border-gray-100 dark:border-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3B82F6"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>

          <!-- 5 Glasses -->
          <div class="flex gap-1">
            <div *ngFor="let g of [0, 1, 2, 3, 4, 5]" class="relative w-6 h-9">
              <svg viewBox="0 0 24 36" class="w-full h-full">
                <defs>
                  <clipPath [attr.id]="'glassClipCompact' + g">
                    <path d="M2,2 L22,2 L18,34 L6,34 Z" />
                  </clipPath>
                </defs>
                <path
                  d="M2,2 L22,2 L18,34 L6,34 Z"
                  fill="#EBF5FF"
                  class="dark:fill-blue-900/20"
                  stroke="#CCE4FF"
                  stroke-width="1"
                />
                <g [attr.clip-path]="'url(#glassClipCompact' + g + ')'">
                  <rect
                    x="0"
                    [attr.y]="36 - getGlassFill(g) * 36"
                    width="24"
                    height="36"
                    fill="#3B82F6"
                    class="transition-all duration-700"
                  />
                </g>
              </svg>
            </div>
          </div>

          <!-- Increment -->
          <button
            (click)="$event.stopPropagation(); increment()"
            class="w-7 h-7 flex items-center justify-center rounded-full bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 transition border border-gray-100 dark:border-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#3B82F6"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Progress Section -->
    <div class="mt-4">
      <div class="flex items-center gap-3">
        <div class="flex-grow h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden">
          <div
            class="h-full bg-blue-500 transition-all duration-1000"
            [style.width.%]="progress"
          ></div>
        </div>
        <span class="text-xs font-bold text-gray-500 dark:text-gray-400">{{ percentage }}%</span>
      </div>
      <p class="text-[12px] font-medium text-gray-500 dark:text-gray-400 mt-1.5">
        {{ remainingLabel }}
      </p>
    </div>
  </div>

  <!-- Footer Stats -->
  <div class="mt-3 rounded-b-2xl pt-1 border-t bg-blue-50 border-gray-100 dark:border-gray-800">
    <div class="flex items-center justify-between p-2">
      <div class="flex flex-col">
        <span class="text-sm font-medium text-gray-400 uppercase tracking-tight"
          >Weekly Progress</span
        >
        <span class="text-sm font-bold text-black">Avg {{ formatMlToL(avg) }}L/Day</span>
      </div>

      <!-- Ring Chart -->
      <div class="relative w-12 h-12 flex items-center justify-center">
        <svg viewBox="0 0 36 36" class="w-full h-full transform -rotate-90">
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="#F2F4F7"
            stroke-width="3.5"
            class="dark:stroke-gray-800"
          />
          <circle
            cx="18"
            cy="18"
            r="16"
            fill="none"
            stroke="#3B82F6"
            stroke-width="3.5"
            stroke-linecap="round"
            [attr.stroke-dasharray]="weeklyGoalPercent + ', 100'"
            class="transition-all duration-1000"
          />
        </svg>
        <span class="absolute text-[9px] font-bold text-[#101828]">{{ weeklyGoalPercent }}%</span>
      </div>
    </div>
  </div>
</div>
